<template>
    <!--
    <h3 v-if="supervisedEntitiesData.length || noResults" class="supervised-results" id="vue-supervised-results" tabindex="-1" ref="seEntities">
        {{ conf.labels.searchresults }} ({{ supervisedEntitiesData.length }} {{ conf.labels.pieces }})
    </h3>-->
    <el-collapse v-if="supervisedEntitiesData.length" class="SE_list list-group" id="supervised-entities-list" aria-labelledby="vue-supervised-results">
        <SupervisedEntitiesItem v-for="entity in paginatedData" :key="entity.groupnumber" :entity="entity" ref="entities" />
    </el-collapse>
    <div v-if="errorMessage" class="error col-sm-12" role="alert">
        {{ conf.labels.errorloadingdata }}
    </div>
    <div v-if="noResults" class="noresults col-sm-12" role="alert">
        {{ conf.labels.noresults }}
    </div>
    <el-pagination background layout="prev, pager, next"
                   v-if="supervisedEntitiesData.length > itemsPerPage"
                   :current-page="currentPage"
                   :page-size="itemsPerPage"
                   :total="supervisedEntitiesData.length"
                   @current-change="handleCurrentChange" />

</template>

<script>
    import { mapState, mapGetters, mapActions } from "vuex";
    import { ref, computed } from 'vue';
    import SupervisedEntitiesItem from './SupervisedEntitiesItem.vue';

    export default {
        data: () => ({
            currentPage: 1,
            pageSize: 30,
        }),
        components: {
            SupervisedEntitiesItem
        },
        computed: {
            ...mapActions([
                'SearchItems'
            ]),
            ...mapState(["conf",
                "countries",
                "countryLanguages",
                "itemsPerPage",
                "supervisedEntitiesData",
                "errorMessage",
                "noResults"]),
            ...mapGetters(["createServicesInCountry",
                ]),
            paginatedData() {
                const start = (this.currentPage - 1) * this.itemsPerPage;
                return this.supervisedEntitiesData.slice(start, start + this.itemsPerPage);
            },
            
            
        },
        methods: {
            handleCurrentChange(page) {
                this.currentPage = page;
            },
            sortAlphabetically(list, propToSortBy) {
                return list.sort((a, b) => {
                    var x = propToSortBy(a).toLowerCase();
                    var y = propToSortBy(b).toLowerCase();
                    if (x < y) { return -1; }
                    if (x > y) { return 1; }
                    return 0;
                })
            },
            sortServicesInCountry(item) {
                if (this.countries && this.countries.length) {
                    let _countries = item["servicesincountry"].reduce((accumulator, currentValue) => {
                        if (accumulator.indexOf(currentValue.countrycode) < 0)
                            accumulator.push(currentValue.countrycode)

                        return accumulator;
                    }, []);

                    let output = _countries.reduce((accumulator, currentValue) => {
                        accumulator[currentValue] = item["servicesincountry"].filter(x => x.countrycode === currentValue).map(x => x.servicename);
                        return accumulator;
                    }, {});

                    let sorted = [];

                    const countries = this.countries;
                    const countryLanguages = this.countryLanguages;
                    const language = this.conf.language;

                    Object.keys(output).forEach(function (key) {
                        var country = countries.find(x => x.countrycode === key);
                        let _lang = countryLanguages[language];
                        var lang = country ? country["countryname" + _lang] : key;
                        sorted.push({ lang: lang, services: output[key] });
                    });

                    sorted.sort((a, b) => a.lang.localeCompare(b.lang));

                    return sorted;
                } else return "";
                
            }
        },
        watch: {
            
        }
    };

</script>